import { render } from "./LogsCard.vue?vue&type=template&id=0d9ef094&scoped=true"
import script from "./LogsCard.vue?vue&type=script&lang=js"
export * from "./LogsCard.vue?vue&type=script&lang=js"

import "./LogsCard.vue?vue&type=style&index=0&id=0d9ef094&scoped=true&lang=css"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9ef094"]])

export default __exports__